import styled, { css } from 'styled-components';

import ShowMoreText from '@libs/react-show-more-text';

export const Container = styled.div`
  display: grid;
  gap: 10px;
  width: 100%;
  padding: 40px 40px 20px 40px;
  border-radius: 8px;
  color: ${({ theme }) => theme.palette.D400};
  box-shadow: 0 10px 20px 0 rgba(58, 58, 58, 0.1);
  position: relative;
  background-color: ${({ theme }) => theme.palette.NL0};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.TABLET})`} {
    margin: 20px 0;
    padding: 23px 16px 21px 16px;
  }
`;

export const CustomShowMoreText = styled(ShowMoreText)`
  font-size: 14px;
  color: ${(p) => p.theme.palette.D400};
  line-height: 1.67;
  white-space: initial;
`;

export const ShowMoreLink = styled.span`
  text-decoration: underline;
  font-weight: 700;
`;

export const FeatureGroupDescription = styled.div`
  color: ${(p) => p.theme.palette.D400};
  font-weight: 400;
  white-space: initial;
`;

export const FeatureListContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  grid-gap: 10px 20px;
  margin-top: 10px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    grid-template-columns: auto;
  }
`;

export const Feature = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;
export const TitleCondition = styled.div`
  margin-bottom: 20px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-bottom: 16px;
  }
`;
export const BodyContainer = styled.div`
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 16px;
`;
export const ConditionWrapper = styled.div<{
  isMargin?: boolean;
}>`
  margin-top: ${({ isMargin }) => (isMargin ? '20px' : '0px')};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: ${({ isMargin }) => (isMargin ? '6px' : '0px')};
  }
`;
export const NonFreeWrapper = styled.div`
  width: 100%;
  text-align: right;
`;
export const SessionNameWrapper = styled.div`
  height: 52px;
  width: 100%;
`;
export const TabsContainer = styled.div<{
  hasCyprus?: boolean;
}>`
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    ${({ hasCyprus }) =>
      hasCyprus
        ? css`
            &&& div {
              display: grid;
              grid-template-columns: 100px 1fr 100px 100px 100px;
            }
          `
        : ''}
  }
`;

export const StyledTabs = styled.div<{
  isTabCount?: boolean;
}>`
  display: flex;
  width: 100%;
  & > :first-child {
    border-radius: ${(props) => (props.isTabCount ? '8px 0px 0px 8px' : '8px')};
  }
  & > :nth-child(2) {
    border-radius: 0px 8px 8px 0px;
  }
`;

export const StyledTab = styled.button<{
  selected?: boolean;
  hover: boolean;
  disabled?: boolean;
  select?: number;
  control?: boolean;
}>`
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  width: unset;
  min-width: unset;
  flex: 1;
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  justify-content: center;
  height: 72px;
  border: none;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    height: 59px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  ${(p) =>
    p.selected
      ? css`
          background-color: ${({ theme }) => theme.palette.R600};
          font-size: 18px;
          font-weight: 700;
        `
      : null}
`;

export const TabText = styled.span<{ isSelected?: boolean }>`
  padding-left: 5px;
  & span {
    white-space: nowrap;
    color: ${({ theme, isSelected }) =>
      isSelected ? theme.palette.white : theme.palette.D300} !important;
    font-weight: 700 !important;
  }
`;

export const TabDateText = styled.span<{ isSelected?: boolean }>`
  & span {
    white-space: nowrap;
    color: ${({ theme, isSelected }) =>
      isSelected ? theme.palette.white : theme.palette.D300} !important;
  }
`;

export const TabMainDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
